import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Locale, type LanguageState } from '@packages/global';
import i18n from '../i18n';

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      locale: Locale.EN_US,
      setLocale: (locale) => {
        set({ locale });
        i18n.changeLanguage(locale);
      },
    }),
    {
      name: 'language-storage',
    }
  )
);
